import React from 'react';
import './SummaryStep.css';
import { BOOKING_STEPS } from '../../constants/bookingSteps';
import { Extra, Modality, Room, Turn } from '../../models/types';
import BookingSelectionPanel from '../BookingSelectionPanel/BookingSelectionPanel';

interface SummaryStepProps {
    shopId: number;
    shopName: string;
    room: Room | null;
    selectedModality: Modality | null;
    selectedDate: Date | null;
    selectedTurn: Turn | null;
    selectedExtras: Extra[];
    availableExtras?: Extra[];
    onRemoveExtra?: (extraId: number) => void;
}

const SummaryStep: React.FC<SummaryStepProps> = ({
    shopId,
    shopName,
    room,
    selectedModality,
    selectedDate,
    selectedTurn,
    selectedExtras,
    availableExtras = [],
    onRemoveExtra,
}) => {
    return (
        <div className="summary-step">
            <BookingSelectionPanel
                isOpen
                onClose={() => undefined}
                currentStep={BOOKING_STEPS.SUMMARY}
                shopId={shopId}
                shopName={shopName}
                room={room}
                selectedDate={selectedDate}
                selectedTurn={selectedTurn}
                selectedModality={selectedModality}
                selectedExtras={selectedExtras}
                availableExtras={availableExtras}
                onRemoveExtra={onRemoveExtra}
                dismissible={false}
            />
        </div>
    );
};

export default SummaryStep;
